import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { AuthContext } from "../../../contexts/Auth";
import { CustomSelect, OptionItem } from "../../form/CustomSelect";
import Image from "../../media/Image";
import { Text } from "../../typography/Text";
import { TitleDescriptionText } from "../../typography/TitleDescriptionText";

const msgKey = "userSelect";

export const UserSelect = ({ value, onChange, busy, userList, placeholder }) => {
    const { me } = useContext(AuthContext);
    return (
        <CustomSelect
            value={value}
            busy={busy}
            onChange={onChange}
            placeholder={placeholder || <FormattedMessage id={`${msgKey}.selectUser`} />}
            isClearable={true}
            isSearchable={true}
            filterOption={(option, searchTerm) => {
                if (!searchTerm || !searchTerm.length) return true;
                const user = userList.find((u) => u.id === option.value);
                return user.fullName.toLowerCase().includes(searchTerm.toLowerCase());
            }}
        >
            {userList?.map((user) => (
                <OptionItem
                    key={user.id}
                    value={user.id}
                    symbol={<Image src={user.picture?.url} rounded size="fit" icon="user" />}
                    label={
                        <TitleDescriptionText
                            title={
                                <>
                                    {user.fullName}
                                    {me?.user.id === user.id ? (
                                        <Text color="base60">
                                            &nbsp;(
                                            <FormattedMessage id={`${msgKey}.me`} />)
                                        </Text>
                                    ) : null}
                                </>
                            }
                            description={!value || value !== user.id ? user.role || user.email : null}
                        />
                    }
                />
            ))}
        </CustomSelect>
    );
};
